import {defineStore} from "pinia";
import {computed, Ref, ref} from "vue";
import {INotification} from "@/interfaces/components/general/INotification";
import {idRandomGenerator} from "cdp-fe-commons-layout";

export const useNotificationStore = defineStore('notification', () => {
    const notifications = ref<Map<string, INotification>>(new Map());
    //Getters
    const notificationsData = computed<Ref<Map<string, INotification>>>(() => notifications);

    //Actions
    function addNotification(notify: INotification) {
        const id = idRandomGenerator(`notify_${notifications.value.size}`);
        notifications.value.set(id, notify);
    }

    function removeNotification(id: string) {
        notifications.value.delete(id);
    }

    return {notificationsData, addNotification, removeNotification}
})